export default __webpack_public_path__ + "static/media/a023-short5.05cee312.jpg";